var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{staticClass:"progress-ring",attrs:{"viewBox":"-50,-50,100,100"}},[_c('path',{staticClass:"progress-ring-ring",attrs:{"d":_vm.path}}),_c('text',{attrs:{"alignment-baseline":"middle","text-anchor":"middle"}},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }